export const BRAND_COLORS = {
  KIA: "#BB162B",
  TOYOTA: "#EB0A1E",
  HYUNDAI: "#002C5F",
  TATA: "#00458C",
  MAHINDRA: "#B8860B",
  MARUTI: "#0F1D38",
  SKODA: "#4BA82E",
  OTHERS: "#808285",
};

export const brandColor = (name) => BRAND_COLORS[name] || "#64748b";

export const ROLE_OPTIONS = [
  { key: "md", label: "Managing Director", role: "md", department: null },
  { key: "accounts", label: "Accounts", role: "accounts", department: null },
  { key: "stock", label: "Stock Incharge", role: "stock", department: null },
  { key: "vp_sales", label: "VP Sales", role: "vp", department: "sales" },
  { key: "zonal_sales", label: "Zonal Manager · Sales", role: "zonal", department: "sales" },
  { key: "manager_sales", label: "Sales Manager", role: "manager", department: "sales" },
  { key: "vp_service", label: "VP Service", role: "vp", department: "service" },
  { key: "zonal_service", label: "Zonal Manager · Service", role: "zonal", department: "service" },
  { key: "manager_service", label: "Service Manager", role: "manager", department: "service" },
  { key: "admin", label: "Admin", role: "admin", department: null },
  { key: "uploader", label: "MIS Uploader", role: "uploader", department: null },
];

export const roleLabel = (u) => {
  if (!u) return "";
  const m = ROLE_OPTIONS.find((o) => o.role === u.role && (o.department || null) === (u.department || null));
  return m ? m.label : u.role;
};

export const basisLabel = (basis) => (basis === "exm" ? "Ex-Maruti TIV" : "Total TIV");

export const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("en-IN"));

export const pct = (n) => (n == null ? "—" : `${Number(n).toFixed(2)}%`);

export const signed = (n) => (n == null ? "—" : `${n > 0 ? "+" : ""}${Number(n).toFixed(2)}`);

export function downloadCSV(filename, headers, rows, basis) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [
    `Share basis:,${basisLabel(basis)}`,
    headers.map(esc).join(","),
    ...rows.map((r) => r.map(esc).join(",")),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function heatColor(value, min, max) {
  if (value == null || max <= min) return "transparent";
  const t = (value - min) / (max - min);
  return `rgba(13, 118, 90, ${0.06 + 0.4 * t})`;
}
